import { useState } from "react";
import { Box, Tab, Tabs, Tooltip } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";

// Components
import UnsentDocuments from "./UnsentDocuments";
import GeneralConditions from "./GeneralConditions";
import PolicyFiles from "./PolicyFiles";
import Header from "../dashboard/Header";



export default function Qualitas() {
  const { t } = useTranslation();
  const theme = useTheme();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: "1600px", mx: "auto" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Header title={t("qualitas.title")} subtitle={t("qualitas.subtitle")} />
      </Box>

      <Box sx={{ mb: 4 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: "48px",
            bgcolor: theme.palette.mode === 'dark' ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0.03)",
            borderRadius: "12px",
            p: 0.5,
            display: "flex",
            maxWidth: "100%",
            "& .MuiTabs-indicator": {
              display: "none",
            },
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: "600",
              fontSize: "0.95rem",
              minHeight: "40px",
              borderRadius: "8px",
              color: theme.palette.mode === 'dark' ? "#a1a4ab" : "#727681",
              transition: "all 0.3s ease",
              px: 4,
              "&.Mui-selected": {
                color: theme.palette.mode === 'dark' ? "#fff" : "#141b2d",
                bgcolor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.1)" : "#fff",
                boxShadow: theme.palette.mode === 'dark' ? "none" : "0 2px 8px rgba(0,0,0,0.05)",
              },
              "&:hover:not(.Mui-selected)": {
                color: theme.palette.mode === 'dark' ? "#fff" : "#141b2d",
                bgcolor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.5)",
              },
            },
          }}
        >
          <Tooltip title={t("qualitas.unsentDocumentsTooltip")} arrow>
            <Tab disableRipple label={t("qualitas.unsentDocuments")} />
          </Tooltip>

          <Tooltip title={t("qualitas.policyDocumentsTooltip")} arrow>
            <Tab disableRipple label={t("qualitas.policyDocuments")} />
          </Tooltip>

          <Tooltip title={t("qualitas.generalConditionsTooltip")} arrow>
            <Tab disableRipple label={t("qualitas.generalConditions")} />
          </Tooltip>
        </Tabs>
      </Box>

      {/* Content wrapper with glassmorphism */}
      <Box
        sx={{
          bgcolor: theme.palette.mode === 'dark' ? "rgba(20, 27, 45, 0.7)" : "#ffffff",
          backdropFilter: "blur(10px)",
          borderRadius: "16px",
          boxShadow: theme.palette.mode === 'dark' ? "0 8px 32px 0 rgba(0, 0, 0, 0.3)" : "0 8px 32px 0 rgba(31, 38, 135, 0.05)",
          border: theme.palette.mode === 'dark' ? "1px solid rgba(255, 255, 255, 0.05)" : "1px solid rgba(0, 0, 0, 0.05)",
          p: { xs: 2, md: 3 },
          minHeight: "500px"
        }}
      >
        {value === 0 && <UnsentDocuments />}
        {value === 1 && <PolicyFiles />}
        {value === 2 && <GeneralConditions />}
      </Box>
    </Box>
  );
}
